<template>
  <div>
    <Header page="manager_users"/>
    <div class="detailUser container">
      <Breadcrumb/>
      <div id="detailUser-main" class="detail-employee">
        <b-row class="w-100" style="margin: auto">
          <b-col cols="12" lg="3" class="col-left-0 col-right-0">
            <div class="infoDetailUser">
              <div class="avatar">
                <img :src="editEmployee.avatar" alt class="avt-modal" />
              </div>
              <div class="text-center afterAvt">
                <h2 class="nameUser">{{truncate(editEmployee.name,10,'...')}}</h2>
                <p class="department">{{truncate(editEmployee.position,10,'...')}}</p>
              </div>
              <div class="text-left second-box">
                <div class="info-table">
                  <span class="label">社員コード</span>
                  <span class="value id">{{truncate(editEmployee.employee_code,10,'...')}}</span>
                </div>
                <div class="info-table">
                  <span class="label">電話番号</span>
                  <span class="value phone">{{truncate(editEmployee.phone,13,'...')}}</span>
                </div>
                <div class="info-table">
                  <span class="label">メールアドレス</span>
                  <span class="value email">{{truncate(editEmployee.email,15,'...')}}</span>
                </div>
              </div>
              <div class="text-center button-box">
                <button class="btn btn-edit btn-rounder w-100" v-if="showAction(editEmployee.role_id)" @click="showModelEdit">
                  <i class="icon-i-edit"></i>
                  <span>編集</span>
                </button>
                <button class="btn btn-second btn-rounder w-100" v-if="showAction(editEmployee.role_id)" @click="showModalDelete">削除</button>
              </div>
            </div>
          </b-col>
          <b-col cols="12" lg="1" class="border-relative">
            <span class="borderLeft-pt"></span>
          </b-col>
          <b-col cols="12" lg="8" class="col-right-0 col-left-0 mb-top-40">
            <HistoryView />
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalDeleteUser @deleteEmployee="deleteEmployee()"/>
    <ModalEditUser/>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import HistoryView from '@/components/share/HistoryView'
import Breadcrumb from '@/components/share/Breadcrumb'
import ModalDeleteUser from '@/views/Manager/EmployeeManager/Delete'
import ModalEditUser from '@/views/Manager/EmployeeManager/Edit'
import {mapState} from 'vuex'
import {ROLE} from '../../../utils/constant'
export default {
  name: 'DetailUser',
  components: {
    Header,
    HistoryView,
    Breadcrumb,
    ModalDeleteUser,
    ModalEditUser
  },
  data () {
    return {

    }
  },
  methods: {
    showModalDelete () {
      this.$root.$emit('bv::show::modal', 'modalDeleteUser', '#modalDeleteUser')
    },
    showModelEdit () {
      this.$root.$emit('bv::show::modal', 'modalEditUser', '#modalEditUser')
      this.$store.dispatch('employee/detailEmployee', {id: this.$route.params.id})
    },
    deleteEmployee () {
      const id = this.$route.params.id
      this.$store.dispatch(`employee/deleteEmployee`, {id: id})
    },
    showAction (value) {
      return value === ROLE.EMPLOYEE
    }
  },
  computed: {
    ...mapState({
      editEmployee: state => state.employee.editEmployee,
      detailEmployee: state => state.employee.editEmployee
    })
  },
  mounted () {
    this.$store.dispatch('employee/getListHistory', {employee_id: this.$route.params.id})
    this.$store.dispatch('employee/detailEmployee', {id: this.$route.params.id})
    window.scrollTo({
      top: 0
    })
  }
}
</script>
<style scoped lang='scss'>
@import '@/assets/stylesheet/user/detail_user.scss';
@import '@/assets/stylesheet/auth/listfile.scss';
</style>



// WEBPACK FOOTER //
// src/views/Manager/EmployeeManager/Detail.vue